import PropTypes from 'prop-types';
import { Box, Typography } from '@mui/material';

/**
 * Linha de configuração: descrição à esquerda, controle à direita.
 * Empilha em xs; lado a lado a partir de sm.
 */
export default function SettingRow({ label, helper, control, sx }) {
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: { xs: 'column', sm: 'row' },
        alignItems: { xs: 'flex-start', sm: 'center' },
        justifyContent: 'space-between',
        gap: 1.5,
        py: 1,
        maxWidth: 720,
        ...sx,
      }}
    >
      <Box sx={{ minWidth: 0 }}>
        <Typography variant="body2">{label}</Typography>
        {helper && (
          <Typography variant="caption" color="text.secondary" sx={{ display: 'block' }}>
            {helper}
          </Typography>
        )}
      </Box>
      <Box sx={{ flexShrink: 0 }}>{control}</Box>
    </Box>
  );
}

SettingRow.propTypes = {
  label: PropTypes.string.isRequired,
  helper: PropTypes.string,
  control: PropTypes.node.isRequired,
  sx: PropTypes.object,
};
